import React, { Fragment, useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import Grid2 from '@mui/material/Grid2';
import CircularProgress from "@mui/material/CircularProgress";
import { fetchQRCode } from "../../action/qrcode";
import { useReactToPrint } from 'react-to-print';
import Alert from "../layout/Alert";
import QRScanner from './QRCodeScanner';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import { useTheme } from '@mui/material/styles';
import { getDeviceModelNumbersList, getModelId } from './../../action/addvcModel'
import { selectMenuProps } from '../../utils/selectMenuProps';
import FormInput from "../Common/FormInputs/MuiTextField";
import AppRadioGroup from "../Common/FormInputs/AppRadioGroup";
import InfoField from "../Common/InfoField/InfoField";
import { SectionHeading, LabelText } from "../Common/Typography/AppTypography";
import AppButton from "../Common/Button/Button";

const formControlSx = (theme) => ({
  width: "100%",
  maxWidth: "100%",
  minWidth: 0,
  boxSizing: "border-box",
  [theme.breakpoints.up("md")]: { maxWidth: 280 },
});
const labelColSx = { minWidth: { md: 140 }, flexShrink: 0 };
// `InputLabel` for MUI outlined selects can render slightly outside the control's
// box when shrunk; the previous `overflow: hidden` clipped it.
const inputColSx = { minWidth: 0, width: "100%", maxWidth: "100%", overflow: "visible" };

const FetchQRCode = ({
    allowedDeviceCategories,
    allowedCompanyBrand,
    setAlert,
    //ModelData: { ModelData, loading },
    ModelData,
    getModelId
}) => {

    const theme = useTheme();

    // Keep default menu anchoring so each dropdown opens right below its own field.
    const menuProps = { ...selectMenuProps };

    const fetchByPSN = "fetchByPSN"
    const fetchByModelId = "fetchByModelId"

    const [fetchQRCodeBy, setFetchQRCodeBy] = useState(fetchByPSN)
    const [productSerialNumber, setProductSerialNumber] = useState("")
    const [resultQRCode, setResultQRCode] = useState(undefined)
    const [totalProductSerialNumbers, setTotalProductSerialNumbers] = useState(0)
    const [totalQRCodeResponseReceived, setTotalQRCodeResponseReceived] = useState(0)
    const [validQRCodeResponseReceived, setValidQRCodeResponseReceived] = useState(0)
    const [qrCodeFetchingInProgress, setQRCodeFetchingInProgress] = useState(false)
    const [verticalSpacing, setVerticalSpacing] = useState(2.9)
    const [horizontalSpacing, setHorizontalSpacing] = useState(2.9)
    const [dpi, setDPI] = useState(500)
    const [qrCodeCopies, setQRCodeCopies] = useState(4)
    const [qrSpacing, setQRSpacing] = useState(0.94)
    const [displayQRCodeScanner, setDisplayQRCodeScanner] = useState(false)

    const [category, setCategory] = useState("")
    const [brandName, setBrandName] = useState("")
    const [searchModelIdBy, setSearchModelIdBy] = useState("searchModelIdByMatter")
    const [modelId, setModelId] = useState("")
    const [modelIdList, setModelIdList] = useState([])

    const [getDataUsingQRCodeScanning, setGetDataUsingQRCodeScanning] = useState(false)


    useEffect(() => {
        if (ModelData && ModelData.ModelData) {
            setModelId(JSON.stringify({ 'modelId': ModelData?.ModelData.modelId, 'modelNumber': ModelData?.ModelData?.modelNumber ?? "" }))
            setModelIdList([{ 'modelId': ModelData?.ModelData.modelId, 'modelNumber': ModelData?.ModelData?.modelNumber ?? "" }])
            setBrandName(ModelData?.ModelData?.brand ?? "")
        }
    }, [ModelData])

    useEffect(() => {
        if (totalQRCodeResponseReceived===0 || totalProductSerialNumbers===0) {
            return;
        }

        if (totalQRCodeResponseReceived===totalProductSerialNumbers) {
            setQRCodeFetchingInProgress(false)
        }
    }, [totalQRCodeResponseReceived, validQRCodeResponseReceived])

    useEffect(() => {
        if (!category || category.length===0 || category==="Select Category") {
            return
        }

        if (!brandName || brandName.length===0 || brandName==="Select Brand") {
            return
        }

        if (brandName && brandName.length!==0 && category && category.length!==0) {

            let isMatterEnabled = searchModelIdBy==="searchModelIdByMatter" ? 'true' : 'false'

            getDeviceModelNumbersList(brandName, category, isMatterEnabled)
                .then((data) => {
                    setModelIdList(data)

                    if (!getDataUsingQRCodeScanning) {
                        setModelId("")
                    }
                })
                .catch((err) => {
                    console.log('Error in Receiving the Model Number List For Category ' + category +
                        'Brand Name ' + brandName)

                    setModelId("")
                    setModelIdList([])
                })
        }
    }, [brandName, category, searchModelIdBy])

    function handleGenerateQRCodeReset() {
        setProductSerialNumber("")
        setResultQRCode(undefined)
        setTotalProductSerialNumbers(0)
        setTotalQRCodeResponseReceived(0)
        setQRCodeFetchingInProgress(false)
        setValidQRCodeResponseReceived(0)
        setVerticalSpacing(2.9)
        setHorizontalSpacing(2.9)
        setQRCodeCopies(4)
        setQRSpacing(0.94)
        setDPI(500)

        setCategory("")
        setBrandName("")
        setModelId("")
        setSearchModelIdBy("searchModelIdByMatter")

        setGetDataUsingQRCodeScanning(false)
        setDisplayQRCodeScanner(false)
    }

    function handleGenerateQRCode() {

        // First Clear the Section which shows the results of QR Codes
        setResultQRCode(undefined)

        // set total Product Serial Numbers to 0
        setTotalProductSerialNumbers(0)

        // reset valid product serial numbers result
        setValidQRCodeResponseReceived(0)

        // Clear the Total Response received
        setTotalQRCodeResponseReceived(0)

        // perform validation checks
        if (fetchQRCodeBy===fetchByModelId) {
            if (!modelId || modelId.length===0) {
                setAlert('Model ID Cannot be Empty', 'danger')
                window.scrollTo(0, 0);
                return
            }
        }
        else {
            if (!productSerialNumber || productSerialNumber.length===0) {
                setAlert('Product Serial Number Cannot be Empty', 'danger')
                window.scrollTo(0, 0);
                return
            }
        }

        if (!qrCodeCopies || qrCodeCopies <= 0 || qrCodeCopies > 5 || qrCodeCopies==="" || parseInt(qrCodeCopies)===NaN) {
            setAlert('Invalid QR Code Copies Value. Should be Greater than 0 and Less than 5', 'danger')
            window.scrollTo(0, 0);
            return
        }
        if (qrSpacing < 0 || parseInt(qrSpacing)===NaN) {
            setAlert('Invalid QR Spacing Value. Should be Greater than  or Equal to 0', 'danger')
            window.scrollTo(0, 0);
            return
        }
        if (!dpi || dpi <= 0 || dpi==="" || parseInt(dpi)===NaN) {
            setAlert('Invalid DPI Value. Must be Greater than or Equal to 1', 'danger')
            window.scrollTo(0, 0);
            return
        }
        if (verticalSpacing < 0 || parseInt(verticalSpacing)===NaN) {
            setAlert('Invalid Vertical Spacing', 'danger')
            window.scrollTo(0, 0);
            return
        }
        if (horizontalSpacing < 0 || parseInt(horizontalSpacing)===NaN) {
            setAlert('Invalid Horizontal Spacing', 'danger')
            window.scrollTo(0, 0);
            return
        }

        setTotalProductSerialNumbers(1)

        let reqParams = {
            'dpi': parseInt(dpi),
            'count': parseInt(qrCodeCopies),
            'qrimage': true
        }

        if (fetchQRCodeBy===fetchByModelId) {
            reqParams['modelId'] = JSON.parse(modelId)?.["modelId"] ?? ""
        }
        else {
            reqParams['psn'] = productSerialNumber
        }

        if (parseInt(qrSpacing) > 0) {
            reqParams["horizontalSpacingInMM"] = parseInt(qrSpacing)
        }

        fetchSingleQRCode(reqParams)
    }

    function fetchSingleQRCode(data) {

        // mark the QR Code Fetching in progress
        setQRCodeFetchingInProgress(true)

        fetchQRCode(data)
            .then((result) => {
                setResultQRCode(result)
                setValidQRCodeResponseReceived(prevState => {
                    return prevState + 1
                })
                setTotalQRCodeResponseReceived(prevState => {
                    return prevState + 1
                })
            })
            .catch((err) => {
                setResultQRCode(undefined)
                setTotalQRCodeResponseReceived(prevState => {
                    return prevState + 1
                })
                setAlert(err?.response?.data?.message ?? err.message, "danger")
                window.scrollTo(0, 0);
            })
    }

    // Printing Process
    const componentToPrintRef = useRef();
    const handlePrint = useReactToPrint({
        // content: () => {
        //     return componentToPrintRef.current
        // }

        // Updated due to version upgrade
        contentRef: componentToPrintRef,
    });

    function handleScanQRCode() {
        setDisplayQRCodeScanner(!displayQRCodeScanner)
    }

    function handleQRCodeScanDetails(qrCodeScanDetails, error) {
        setGetDataUsingQRCodeScanning(true)
        setResultQRCode(undefined)

        if(error){
            setAlert(error, "danger")
            setCategory("")
            setProductSerialNumber("")
            setBrandName("")
            setModelId("")
            window.scrollTo(0, 0);
            return
        }

        if (fetchQRCodeBy===fetchByModelId) {

            // check if the qr code is PSN based or Model Based
            if (qrCodeScanDetails && qrCodeScanDetails.productSerialNumber) {
                setAlert("Scanned QR Code is PSN Based QR Code. Use Model ID Based QR Codes", "danger")
                window.scrollTo(0, 0);
                return
            }

            setAlert("QR Code Scan Successful", "success")
            window.scrollTo(0, 0);

            getModelId(qrCodeScanDetails.modelId);
            setCategory(qrCodeScanDetails.category)

            if (qrCodeScanDetails.isMatter) {
                setSearchModelIdBy("searchModelIdByMatter")
            }
            else {
                setSearchModelIdBy("searchModelIdByNonMatter")
            }
        }
        else {
            // check if the qr code is PSN based or Model Based
            if (qrCodeScanDetails && !qrCodeScanDetails.productSerialNumber) {
                setAlert("Scanned QR Code is not a PSN Based QR Code.", "danger")
                window.scrollTo(0, 0);
                return
            }

            setAlert("QR Code Scan Successful", "success")
            window.scrollTo(0, 0);

            setProductSerialNumber(qrCodeScanDetails.productSerialNumber)
        }
    }

    function onChangeSearchQrCodeBy(searchQrCodeBy) {
        setFetchQRCodeBy(searchQrCodeBy)
        handleGenerateQRCodeReset()
    }

    return (
        <Fragment>
            <Paper sx={{ p: { xs: 1.5, sm: 2 }, boxShadow: 2, borderRadius: 1, mb: 2, width: "100%", minWidth: 0, boxSizing: "border-box", overflow: "visible" }}>
                <Alert />
                <Box sx={{ width: "100%", minWidth: 0, maxWidth: "100%", overflow: "visible" }}>
                    <Grid2 container spacing={2} sx={{ mb: 2, alignItems: "center", width: "100%", minWidth: 0, maxWidth: "100%" }}>
                        <Grid2 size={{ xs: 12, md: 2 }} sx={{ ...labelColSx, alignSelf: { md: "center" } }}>
                            <LabelText>Fetch QR Code By:</LabelText>
                        </Grid2>
                        <Grid2 size={{ xs: 12, md: 10 }} sx={inputColSx}>
                            <AppRadioGroup
                                row
                                name="fetchQRCodeBy"
                                value={fetchQRCodeBy}
                                onChange={(e) => onChangeSearchQrCodeBy(e.target.value)}
                                formControlSx={{ ml: "-11px" }}
                                optionLabelSx={{ whiteSpace: "nowrap" }}
                                options={[
                                  { label: "Search by PSN", value: fetchByPSN },
                                  { label: "Search By Model Number", value: fetchByModelId },
                                ]}
                            />
                        </Grid2>
                    </Grid2>
                    {
                        fetchQRCodeBy == fetchByPSN && <Grid2 container spacing={2} sx={{ mb: 2, alignItems: "center", width: "100%", minWidth: 0, maxWidth: "100%" }}>
                            <Grid2 size={{ xs: 12, md: 2 }} sx={{ ...labelColSx, alignSelf: { md: "center" } }}>
                                <LabelText>Product Serial Number:</LabelText>
                            </Grid2>
                            <Grid2 size={{ xs: 12, md: 10 }} sx={inputColSx}>
                                <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 1 }}>
                                    <FormInput
                                        label="Product Serial Number"
                                        placeholder="Enter Product Serial Number"
                                        value={productSerialNumber}
                                        onChange={(e) => setProductSerialNumber(e.target.value)}
                                        sx={{ ...formControlSx(theme), flex: '1 1 200px' }}
                                    />
                                    <Tooltip title="Click to Scan QR Code" arrow>
                                        <IconButton onClick={handleScanQRCode} sx={{ color: 'black', '&:hover': { color: 'black', backgroundColor: 'rgba(0,0,0,0.04)' } }} size="large" aria-label="Scan QR Code">
                                            <QrCode2Icon fontSize="large" />
                                        </IconButton>
                                    </Tooltip>
                                </Box>
                            </Grid2>
                        </Grid2>
                    }
                    {
                        fetchQRCodeBy == fetchByModelId && <Fragment>
                            <Grid2 container spacing={2} sx={{ mb: 2, alignItems: "center", width: "100%", minWidth: 0, maxWidth: "100%" }}>
                                <Grid2 size={{ xs: 12, md: 2 }} sx={{ ...labelColSx, alignSelf: { md: "center" } }}>
                                    <LabelText>Category:</LabelText>
                                </Grid2>
                                <Grid2 size={{ xs: 12, md: 10 }} sx={inputColSx}>
                                    <FormInput sx={formControlSx(theme)}
                                        type="select"
                                        label="Select Category"
                                        value={category}
                                        onChange={(e) => {
                                            setCategory(e.target.value)
                                            setGetDataUsingQRCodeScanning(false)
                                        }}
                                        options={allowedDeviceCategories.map(cat => ({ label: cat, value: cat }))}
                                        slotProps={{ select: { MenuProps: menuProps } }}
                                    />
                                </Grid2>
                            </Grid2>
                            <Grid2 container spacing={2} sx={{ mb: 2, alignItems: "center", width: "100%", minWidth: 0, maxWidth: "100%" }}>
                                <Grid2 size={{ xs: 12, md: 2 }} sx={{ ...labelColSx, alignSelf: { md: "center" } }}>
                                    <LabelText>Brand:</LabelText>
                                </Grid2>
                                <Grid2 size={{ xs: 12, md: 10 }} sx={inputColSx}>
                                    <FormInput sx={formControlSx(theme)}
                                        type="select"
                                        label="Select Brand"
                                        value={brandName}
                                        onChange={(e) => {
                                            setBrandName(e.target.value)
                                            setGetDataUsingQRCodeScanning(false)
                                        }}
                                        options={allowedCompanyBrand.map(brand => ({ label: brand, value: brand }))}
                                        slotProps={{ select: { MenuProps: menuProps } }}
                                    />
                                </Grid2>
                            </Grid2>
                            <Grid2 container spacing={2} sx={{ mb: 2, alignItems: "center", width: "100%", minWidth: 0, maxWidth: "100%" }}>
                                <Grid2 size={{ xs: 12, md: 2 }} sx={{ ...labelColSx, alignSelf: { md: "center" } }}>
                                    <LabelText>Search Model Number By:</LabelText>
                                </Grid2>
                                <Grid2 size={{ xs: 12, md: 10 }} sx={inputColSx}>
                                    <AppRadioGroup
                                        row
                                        name="searchModelIdBy"
                                        value={searchModelIdBy}
                                        onChange={(e) => {
                                            setSearchModelIdBy(e.target.value)
                                            setGetDataUsingQRCodeScanning(false)
                                        }}
                                        formControlSx={{ ml: "-11px" }}
                                        optionLabelSx={{ whiteSpace: "nowrap" }}
                                        options={[
                                          { label: "Matter Enabled", value: "searchModelIdByMatter" },
                                          { label: "Non Matter Enabled", value: "searchModelIdByNonMatter" },
                                        ]}
                                    />
                                </Grid2>
                            </Grid2>
                            <Grid2 container spacing={2} sx={{ mb: 2, alignItems: "center", width: "100%", minWidth: 0, maxWidth: "100%" }}>
                                <Grid2 size={{ xs: 12, md: 2 }} sx={{ ...labelColSx, alignSelf: { md: "center" } }}>
                                    <LabelText>Model Number:</LabelText>
                                </Grid2>
                                <Grid2 size={{ xs: 12, md: 10 }} sx={inputColSx}>
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 1 }}>
                                        <FormInput
                                            type="select"
                                            label="Select Model Number"
                                            value={modelId}
                                            onChange={(e) => setModelId(e.target.value)}
                                            options={modelIdList.map(model => ({
                                                label: model.modelNumber,
                                                value: JSON.stringify({ modelId: model.modelId, modelNumber: model.modelNumber })
                                            }))}
                                            slotProps={{ select: { MenuProps: menuProps } }}
                                            sx={{ ...formControlSx(theme), flex: '1 1 200px' }}
                                        />
                                        <Tooltip title="Click to Scan QR Code" arrow>
                                            <IconButton onClick={handleScanQRCode} sx={{ color: 'black', '&:hover': { color: 'black', backgroundColor: 'rgba(0,0,0,0.04)' } }} size="large" aria-label="Scan QR Code">
                                                <QrCode2Icon fontSize="large" />
                                            </IconButton>
                                        </Tooltip>
                                    </Box>
                                </Grid2>
                            </Grid2>
                        </Fragment>
                    }

                    {
                        displayQRCodeScanner &&
                        <Grid2 container spacing={2} sx={{ mb: 2, alignItems: "center", width: "100%", minWidth: 0, maxWidth: "100%" }}>
                            <Grid2 size={{ xs: 12, md: 2 }} sx={{ ...labelColSx, alignSelf: { md: "center" } }}>
                                <LabelText>Scan QR Code:</LabelText>
                            </Grid2>
                            <Grid2 size={{ xs: 12, md: 10 }} sx={inputColSx}>
                                <QRScanner qrCodeScanDetailsHandler={handleQRCodeScanDetails}/>
                            </Grid2>
                        </Grid2>
                    }
                    <Grid2 container spacing={2} sx={{ mb: 2, alignItems: "center", width: "100%", minWidth: 0, maxWidth: "100%" }}>
                        <Grid2 size={{ xs: 12, md: 2 }} sx={{ ...labelColSx, alignSelf: { md: "center" } }}>
                            <LabelText>QR Code Copies:</LabelText>
                        </Grid2>
                        <Grid2 size={{ xs: 12, md: 10 }} sx={inputColSx}>
                            <FormInput sx={formControlSx(theme)}
                                type="number"
                                value={qrCodeCopies}
                                onChange={(e) => setQRCodeCopies(e.target.value)}
                                onKeyDown={(e) => {
                                    ['e', 'E', '+', '-', '.'].includes(e.key) && e.preventDefault();
                                }}
                            />
                        </Grid2>
                    </Grid2>
                    <Grid2 container spacing={2} sx={{ mb: 2, alignItems: "center", width: "100%", minWidth: 0, maxWidth: "100%" }}>
                        <Grid2 size={{ xs: 12, md: 2 }} sx={{ ...labelColSx, alignSelf: { md: "center" } }}>
                            <LabelText>QR Spacing (In mm):</LabelText>
                        </Grid2>
                        <Grid2 size={{ xs: 12, md: 10 }} sx={inputColSx}>
                            <FormInput sx={formControlSx(theme)}
                                type="number"
                                value={qrSpacing}
                                onChange={(e) => setQRSpacing(e.target.value)}
                            />
                        </Grid2>
                    </Grid2>
                    <Grid2 container spacing={2} sx={{ mb: 2, alignItems: "center", width: "100%", minWidth: 0, maxWidth: "100%" }}>
                        <Grid2 size={{ xs: 12, md: 2 }} sx={{ ...labelColSx, alignSelf: { md: "center" } }}>
                            <LabelText>Spacing (In mm):</LabelText>
                        </Grid2>
                        <Grid2 size={{ xs: 12, md: 10 }} sx={inputColSx}>
                            <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, flexWrap: "wrap", gap: { xs: 1.5, sm: 2 }, maxWidth: { xs: "100%", md: 280 }, width: "100%", minWidth: 0 }}>
                                <Box sx={{ width: { xs: "100%", sm: "auto" }, flex: { sm: "1 1 100px" }, minWidth: 0, maxWidth: { sm: 130 } }}>
                                    <LabelText sx={{ fontSize: 12, mb: 0.5, display: "block" }}>Vertical Spacing</LabelText>
                                    <FormInput
                                        placeholder="2.9"
                                        type="number"
                                        value={verticalSpacing}
                                        onChange={(e) => setVerticalSpacing(e.target.value)}
                                        sx={{ width: "100%" }}
                                    />
                                </Box>
                                <Box sx={{ width: { xs: "100%", sm: "auto" }, flex: { sm: "1 1 100px" }, minWidth: 0, maxWidth: { sm: 130 } }}>
                                    <LabelText sx={{ fontSize: 12, mb: 0.5, display: "block" }}>Horizontal Spacing</LabelText>
                                    <FormInput
                                        placeholder="2.9"
                                        type="number"
                                        value={horizontalSpacing}
                                        onChange={(e) => setHorizontalSpacing(e.target.value)}
                                        sx={{ width: "100%" }}
                                    />
                                </Box>
                            </Box>
                        </Grid2>
                    </Grid2>
                    <Grid2 container spacing={2} sx={{ mb: 2, alignItems: "center", width: "100%", minWidth: 0, maxWidth: "100%" }}>
                        <Grid2 size={{ xs: 12, md: 2 }} sx={{ ...labelColSx, alignSelf: { md: "center" } }}>
                            <LabelText>DPI:</LabelText>
                        </Grid2>
                        <Grid2 size={{ xs: 12, md: 10 }} sx={inputColSx}>
                            <FormInput sx={formControlSx(theme)}
                                type="number"
                                value={dpi}
                                onChange={(e) => setDPI(e.target.value)}
                            />
                        </Grid2>
                    </Grid2>

                    <Grid2 container spacing={2} sx={{ mt: 1, mb: 2, alignItems: "center", width: "100%", minWidth: 0, maxWidth: "100%" }}>
                        <Grid2 size={12}>
                            <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, flexWrap: "wrap", gap: 1.5, alignItems: { xs: "stretch", sm: "center" }, justifyContent: "flex-start", width: "100%", minWidth: 0, maxWidth: "100%" }}>
                                <AppButton
                                    variant="primary"
                                    onClick={handleGenerateQRCode}
                                    disabled={qrCodeFetchingInProgress ? true : false}
                                >
                                    {
                                        qrCodeFetchingInProgress ? <Fragment>
                                            <CircularProgress size="2em" style={{ color: "#AFB42B", marginTop: "5px" }} />
                                        </Fragment>
                                            : "Get QR Code Details"
                                    }
                                </AppButton>
                                <AppButton
                                    variant="ghost"
                                    onClick={handleGenerateQRCodeReset}
                                    disabled={qrCodeFetchingInProgress ? true : false}
                                >
                                    Reset
                                </AppButton>
                            </Box>
                        </Grid2>
                    </Grid2>
                </Box>
            </Paper>
            {/*Component to Print QR Code. Here Print the QR Codes but donot display it to users.
                Directly print them in the print console window
            */}
            <div style={{ display: 'none' }}>
                <ComponentToPrint ref={componentToPrintRef} qrCodeDetails={resultQRCode} vSpacing={verticalSpacing} hSpacing={horizontalSpacing} dpi={dpi} />
            </div>
            {
                resultQRCode && resultQRCode!==undefined &&
                <Fragment>
                    <Paper sx={{ p: 2, boxShadow: 2, borderRadius: 1 }}>
                        <SectionHeading style={{ marginTop: '20px', marginBottom: '16px' }}>
                            Product Serial Number Details
                        </SectionHeading>

                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
                            <InfoField label="Category" value={resultQRCode.category} />
                            <InfoField label="Model ID" value={resultQRCode.modelId} />
                            <InfoField label="Matter Enabled" value={resultQRCode.isMatter ? "True" : "False"} />
                            <InfoField label="Product ID" value={resultQRCode.productId} />
                            <InfoField label="QR Code" value={resultQRCode.qrCode} />
                            <InfoField label="QR Image" value={
                                    <AppButton variant="primary" onClick={() => handlePrint()}>
                                        Print QR Code
                                    </AppButton>
                                } />
                        </Box>
                    </Paper>
                </Fragment>
            }
        </Fragment>
    );
}

const ComponentToPrint = React.forwardRef((props, ref) => (
    <div ref={ref}>
        {
            props.qrCodeDetails && props.qrCodeDetails.qrImage && props.qrCodeDetails.qrImage!=="" &&
            <PrintTemplate qrCodeDetails={props.qrCodeDetails} vSpacing={parseInt(props.vSpacing)} hSpacing={parseInt(props.hSpacing)} dpi={props.dpi} />
        }
    </div>
));

const PrintTemplate = ({ qrCodeDetails, vSpacing, hSpacing, dpi }) => {

    function getContent() {
        let vSpacingInPixels = "", hSpacingInPixels = ""

        if (parseInt(vSpacing)===0) {
            vSpacingInPixels = "0px"
        }
        else {
            vSpacingInPixels = (vSpacing * (dpi / 25.4)) + "px"
        }

        if (parseInt(hSpacing)===0) {
            hSpacingInPixels = "0px"
        }
        else {
            hSpacingInPixels = (hSpacing * (dpi / 25.4)) + "px"
        }

        return <div>
            <img src={"data:image/png;base64," + qrCodeDetails.qrImage}
                style={{ position: 'relative', marginTop: vSpacingInPixels, marginLeft: hSpacingInPixels }} />
        </div>
    }

    return (
        <Fragment>
            <div>
                {getContent()}
            </div>
        </Fragment>
    )
};

const mapStateToProps = (state) => ({
    ModelData: state.getModel
});

export default connect(mapStateToProps, {
    getModelId,
})(FetchQRCode);